import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Form, Button, Row, Col, Card } from "react-bootstrap";
import axiosInstance from "../../axiosInstance";
import ChampDate from '../ChampDate/ChampDate';


const EMPTY_FORM = {
  expertise: {
    name: "",
    reference: "",
  },
  contract: {
    reference: "",
    startDate: "",
    referenceCG: "",
    compagnie: null,
  },
  claims: {
    reference: "",
    dateClaims: "",
    adress: "",
    guarantees: [],
  },
  persons: [],
};

function ExpertiseFullForm() {
  const { expertiseId } = useParams();

  const [form, setForm] = useState(EMPTY_FORM);
  const [guarantees, setGuarantees] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [loading, setLoading] = useState(false);

  // ------------------------------------------------------------------
  // Chargement des listes (garanties / assureurs)
  // ------------------------------------------------------------------
  useEffect(() => {
    axiosInstance.get(`/guarantee/`)
      .then(res => setGuarantees(res.data));

    axiosInstance.get("/insurance/")
      .then(res => setInsurances(res.data));
  }, []);

  // ------------------------------------------------------------------
  // Submit
  // ------------------------------------------------------------------
  const handleSubmit = async () => {
    setLoading(true);
    try {
      await axiosInstance.put(
        `/expertises/create-full/${expertiseId}/`,
        form
      );
      alert("Expertise enregistrée ✅");
    } catch (e) {
      console.error(e);
      alert("Erreur lors de l'enregistrement");
    } finally {
      setLoading(false);
    }
  };

  // ------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------
  const update = (path, value) => {
    setForm(prev => ({
      ...prev,
      [path]: {
        ...prev[path],
        ...value,
      }
    }));
  };

  // ------------------------------------------------------------------
  // RENDER
  // ------------------------------------------------------------------
  return (
    <Container fluid className="mt-4">
      <h3>📋 Dossier d’expertise</h3>

      {/* ============================================================
          EXPERTISE
      ============================================================ */}
      <Card className="mb-4">
        <Card.Header>Expertise</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Control
                placeholder="Nom de l'expertise"
                value={form.expertise.name}
                onChange={e => update("expertise", { name: e.target.value })}
              />
            </Col>
            <Col md={6}>
              <Form.Control
                placeholder="Référence"
                value={form.expertise.reference}
                onChange={e => update("expertise", { reference: e.target.value })}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ============================================================
          CONTRAT
      ============================================================ */}
      <Card className="mb-4">
        <Card.Header>Contrat</Card.Header>
        <Card.Body>
          <Row className="mb-2">
            <Col md={6}>
              <Form.Control
                placeholder="Référence contrat"
                value={form.contract.reference}
                onChange={e => update("contract", { reference: e.target.value })}
              />
            </Col>
            <Col md={6}>
              <ChampDate
                size="small"
                value={form.contract.startDate}
                onChange={e => update("contract", { startDate: e.target.value })}
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Control
                placeholder="Conditions générales"
                value={form.contract.referenceCG}
                onChange={e => update("contract", { referenceCG: e.target.value })}
              />
            </Col>
            <Col md={6}>
              <Form.Select
                value={form.contract.compagnie || ""}
                onChange={e => update("contract", { compagnie: e.target.value || null })}
              >
                <option value="">Assureur</option>
                {insurances.map(i => (
                  <option key={i.id} value={i.id}>{i.name}</option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ============================================================
          SINISTRE
      ============================================================ */}
      <Card className="mb-4">
        <Card.Header>Sinistre</Card.Header>
        <Card.Body>
          <Row className="mb-2">
            <Col md={4}>
              <Form.Control
                placeholder="Référence sinistre"
                value={form.claims.reference}
                onChange={e => update("claims", { reference: e.target.value })}
              />
            </Col>
            <Col md={4}>
              <ChampDate
                size="small"
                value={form.claims.dateClaims}
                onChange={e => update("claims", { dateClaims: e.target.value })}
              />
            </Col>
          </Row>

          <Form.Control
            as="textarea"
            rows={2}
            placeholder="Adresse du sinistre"
            value={form.claims.adress}
            onChange={e => update("claims", { adress: e.target.value })}
          />

          <hr />

          <strong>Garanties</strong>
          {guarantees.map(g => (
            <Form.Check
              key={g.id}
              label={g.name}
              checked={form.claims.guarantees.includes(g.id)}
              onChange={e => {
                const list = e.target.checked
                  ? [...form.claims.guarantees, g.id]
                  : form.claims.guarantees.filter(id => id !== g.id);

                update("claims", { guarantees: list });
              }}
            />
          ))}
        </Card.Body>
      </Card>

      {/* ============================================================
          SUBMIT
      ============================================================ */}
      <div className="text-end">
        <Button
          variant="primary"
          disabled={loading}
          onClick={handleSubmit}
        >
          💾 Enregistrer le dossier
        </Button>
      </div>
    </Container>
  );
}

export default ExpertiseFullForm;
